import React from 'react'
import Lottie from 'lottie-react';
import "./Current_rank_main_card_lottie.css";
import animationData from './Current_rank_main_card_lottie.json';

function Current_rank_main_card_lottie() {
    return (
        <section className='Current_rank_main_card_animation'>
            <Lottie
                animationData={animationData}
                loop={true}
                autoplay={true}
                className="arrow_lottie"
            />
        </section>
    )
}

export default Current_rank_main_card_lottie;